// Show/Hide Predicitve Search
document.addEventListener("DOMContentLoaded", () => {
  // Only Desktop
  if (window.innerWidth >= 750) {
    let isClosing = false;

    document.addEventListener("click", (event) => {
      if (isClosing) return;

      const expandedEl = document.querySelector(".predictive-search--expanded");
      if (!expandedEl) return;

      const clickedInside = expandedEl.contains(event.target);
      const clickedInput = event.target.closest('input.search-input');

      // If click not in the search area and not in the input
      if (!clickedInside && !clickedInput) {
        isClosing = true;
        expandedEl.classList.remove("predictive-search--expanded");

        // Also hide search content (visually)
        const wrapper = document.querySelector(".predictive-search-form__content-wrapper");
        if (wrapper) wrapper.setAttribute("hidden", "true");

        setTimeout(() => {
          isClosing = false;
        }, 100);
      }
    });
  }
});
